import { useContent } from "@/contexts/ContentContext";

export default function Marquee() {
  const { content } = useContent();
  const text = content?.marquee_text || "MADE IN USA — UV PROTECTED — FIBERGLASS REINFORCED — NEVER RUSTS";
  // Build repeated string for seamless loop
  const repeated = Array(6).fill(text).join("    •    ");

  return (
    <div
      className="bg-[#091526] text-[#F4F4F5] border-y-2 border-[#091526] overflow-hidden py-5"
      data-testid="marquee"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        <div className="font-display text-2xl sm:text-3xl tracking-wide pr-12">{repeated}</div>
        <div className="font-display text-2xl sm:text-3xl tracking-wide pr-12">{repeated}</div>
      </div>
    </div>
  );
}
